export const VERSION='v1'
export const LOGIN_URL=`/${VERSION}/auth/login`
export const REFRESH_TOKEN_URL=`/${VERSION}/auth/refresh`
export const RESET_PASS=`/${VERSION}/auth/reset-password`
export const FORGOT_PASS=`/${VERSION}/auth/forgot-password`